export const GET_APPLICATIONS = gql`
    query RetrieveMerchantApplications(
        $searchText: String
        $filters: FiltersInput
        $page: PageFilters
    ) {
        retrieveMerchantApplications(searchText: $searchText, filters: $filters, page: $page) {
            total
            page
            pageSize
            data {
                id
                status
                merchantName
                partnerName
                partnerOfPartnerName
                serviceType
                worldpayPO
                sellersName
                dateSubmitted
            }
        }
    }
`;
export const GET_APPLICATION = gql`
    query RetrieveMerchantApplication($id: Int!) {
        retrieveMerchantApplication(id: $id) {
            id
            status
            businessInformation
            merchantInformation
            partnerId
            serviceRequirements
            outletInformation
            supportingDocuments
            terminalId
            authorId
            mid
            isServiceApplication
            worldpayPO
            merchantAccountNumber
            sentToWorldpayAt
            partner {
                firstName
                lastName
                business {
                    legalName
                }
                countryDetails {
                    alpha2Code
                }
            }
            adobeSignJobs {
                jobId
                principalSignatureIndex
            }
            author {
                firstName
                lastName
                email
            }
            service {
                expiryDate
            }
            merchant {
                id
                merchantAccountNumber
            }
        }
    }
`;

export const GET_LATEST_ADOBE_SIGN_JOB = gql`
    query LatestAdobeSignJob($applicationId: Int!) {
        latestAdobeSignJob(applicationId: $applicationId) {
            id
            jobId
            notifiedAt
            applicationId
            createdAt
            canResend
        }
    }
`;

export const CANCEL_MERCHANT_APPLICATION = gql`
    mutation CancelMerchantApplication($applicationIds: [Int!]!) {
        cancelMerchantApplication(applicationIds: $applicationIds)
    }
`;

export const GET_APPLICATION_BY_SERVICE_ID = gql`
    query GetApplicationByServiceId($serviceId: Int!) {
        getApplicationByServiceId(serviceId: $serviceId)
    }
`;

export const CONTINUE_TRIAL_MERCHANT_SERVICE = gql`
    mutation trialMerchantContinueService($input: TrialMerchantContinueServiceInput!) {
        trialMerchantContinueService(input: $input)
    }
`;
